function openCartDrawer() {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('has-cart-open');
}

function closeCartDrawer() {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    document.body.classList.remove('has-cart-open');
}

function formatMoney(cents, format) {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || window.theme?.moneyFormat || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number == null) {
            return '0';
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)?.[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        case 'amount_with_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', '.');
            break;
        case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ', '.');
            break;
        case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'", '.');
            break;
        default:
            value = formatWithDelimiters(cents, 2);
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

async function getCart() {
    return fetch('/cart.js').then((res) => res.json());
}

function updateCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
        if (cart.item_count > 0) {
            const count = cart.item_count < 10 ? `0${cart.item_count}` : cart.item_count;
            el.textContent = count;
        } else {
            el.textContent = '';
        }
    });
}

function renderCartDrawer(cart) {
    const content = document.querySelector('[data-cart-drawer-content]');
    if (!content) return;

    if (cart.item_count === 0) {
        let emptyHtml = '';
        const emptyText = window.theme.hasOwnProperty('cartDrawerEmptyText') ? window.theme.cartDrawerEmptyText : 'Your cart is empty.';
        const shopNowLabel = window.theme.hasOwnProperty('cartDrawerShopNowLabel') ? window.theme.cartDrawerShopNowLabel : 'Shop now';

        if (emptyText) {
            emptyHtml += `<p>${emptyText}</p>`;
        }
        if (shopNowLabel) {
            emptyHtml += `<a href="/collections/all">${shopNowLabel}</a>`;
        }

        content.innerHTML = `
        <div class="iou-cart-drawer__empty">
          ${emptyHtml}
        </div>
      `;
        return;
    }

    const itemsHtml = cart.items
        .map((item, index) => {
            const line = index + 1;
            const image = item.image
                ? `<img src="${item.image}" alt="${item.product_title}">`
                : '';

            const variantTitle =
                item.variant_title && item.variant_title !== 'Default Title'
                    ? `<p>${item.variant_title}</p>`
                    : '';

            return `
          <div class="iou-cart-drawer__item">
            ${image}
  
            <div>
              <h3>${item.product_title}</h3>
              ${variantTitle}
              <p>${formatMoney(item.final_line_price)}</p>
  
              <div class="iou-cart-drawer__qty">
                <button type="button" data-cart-change data-line="${line}" data-quantity="${item.quantity - 1}">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-cart-change data-line="${line}" data-quantity="${item.quantity + 1}">+</button>
              </div>
            </div>
          </div>
        `;
        })
        .join('');

    const subtotalLabel = window.theme.cartDrawerSubtotalLabel || 'Subtotal';
    const checkoutLabel = window.theme.cartDrawerCheckoutLabel || 'Checkout';

    content.innerHTML = `
      <div class="iou-cart-drawer__items">
        ${itemsHtml}
      </div>
  
      <div class="iou-cart-drawer__footer">
        <div class="iou-cart-drawer__subtotal">
          <span>${subtotalLabel}</span>
          <span>${formatMoney(cart.total_price)}</span>
        </div>
  
        <a href="/checkout" class="iou-cart-drawer__checkout">
          ${checkoutLabel}
        </a>
      </div>
    `;
}

async function refreshCartUI() {
    const cart = await getCart();
    updateCartCount(cart);
    renderCartDrawer(cart);
}

document.addEventListener('click', async function (event) {
    const openButton = event.target.closest('[data-cart-open]');
    const closeButton = event.target.closest('[data-cart-close]');
    const changeButton = event.target.closest('[data-cart-change]');
    const toggleButton = event.target.closest('[data-cart-toggle]');

    if (toggleButton) {
        event.preventDefault();
        const drawer = document.querySelector('[data-cart-drawer]');
        if (drawer && drawer.classList.contains('is-open')) {
            closeCartDrawer();
        } else {
            openCartDrawer();
            refreshCartUI();
        }
        return;
    }

    if (openButton) {
        event.preventDefault();
        openCartDrawer();
        refreshCartUI();
    }

    if (closeButton) {
        event.preventDefault();
        closeCartDrawer();
    }

    if (changeButton) {
        event.preventDefault();

        const line = Number(changeButton.dataset.line);
        const quantity = Number(changeButton.dataset.quantity);

        // Optimistically open drawer (it should already be open)
        openCartDrawer();

        try {
            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify({ line, quantity })
            });

            const cart = await response.json();
            updateCartCount(cart);
            renderCartDrawer(cart);
        } catch (error) {
            console.error('Error updating cart:', error);
            refreshCartUI();
        }
    }
});

document.addEventListener('submit', async function (event) {
    const form = event.target.closest('.iou-product-form');
    if (!form) return;

    // Respect size selection validation
    const variantInput = form.querySelector('[data-variant-input]');
    if (variantInput && !variantInput.value) {
        return; // Let shop.js handle the UI error, do not open drawer
    }

    event.preventDefault();

    const submitButton = form.querySelector('[type="submit"]');
    if (submitButton) {
        submitButton.disabled = true;
        const addingText = window.theme?.addingText || 'Adding...';
        if (submitButton.tagName === 'INPUT') {
            submitButton.value = addingText;
        } else {
            submitButton.textContent = addingText;
        }
    }

    const formData = new FormData(form);

    try {
        // 2. Add to cart
        await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        });

        // 3. Refresh UI
        await refreshCartUI();
        
        // 4. Open drawer on success
        openCartDrawer();
    } catch (error) {
        console.error('Error adding to cart:', error);
    } finally {
        if (submitButton) {
            submitButton.disabled = false;
            const originalText = submitButton.dataset.originalText || 'Add to cart';
            if (submitButton.tagName === 'INPUT') {
                submitButton.value = originalText;
            } else {
                submitButton.textContent = originalText;
            }
        }
    }
});

document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCartDrawer();
});